export default __webpack_public_path__ + "static/media/pauseImage.66b1bfb8.png";